import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import { Tab } from 'components/Tab';
import { ReactComponent as AccmeLogo } from 'globals/images/accme-logo.svg';
import { ReactComponent as JALogo } from 'globals/images/ja-logo.svg';

// Store
import { ITaxonomyTerm } from 'core/models';
import { isJASelector } from 'store/user/selectors';

// Types
interface INavProps {
  items: ITaxonomyTerm[];
}

export const Nav = (props: INavProps): ReactElement => {
  const { items = [] } = props;
  const isJa: boolean = useSelector(isJASelector);

  return (
    <>
      <div className="logo">
        <Link to="/">{isJa ? <JALogo /> : <AccmeLogo />}</Link>
      </div>
      <nav>
        {items.map((term: ITaxonomyTerm) => (
          <Tab key={term.id} title={term.name} link={term.description || ''} exact={false} />
        ))}
      </nav>
    </>
  );
};
